import React, { Component } from "react";
import withContext from "../../../withContext";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Service from '../../service/Service';
import './feedback.css';

const service = new Service();

class Feedback extends Component {
    constructor(props) {
        super(props);
        let authData='';
    
        this.state = {
            isLoggedin: global.ftk !== '',
            isDesktop: true,
            feedbacktext:'',
            feedbackError:''
        };

        if (__isBrowser__ && window.__initialData__ && window.__initialData__["initialData"] ) {
            authData = window.__initialData__["authData"];

            delete window.__initialData__;
        } 

    }

    componentDidMount() {
        this.updateDeviceType(); // calculate first time
        window.addEventListener('resize', this.updateDeviceType);

        const adpushup = window.adpushup = window.adpushup || {};
        adpushup.que = adpushup.que || [];
        adpushup.que.push(function () {
            adpushup.triggerAd("c21ba44c-f89a-460f-bbb9-bc29c66647af");
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDeviceType);
    }

    updateDeviceType = () => {
        const isDesktop = window.innerWidth >= 768;
        if (this.state.isDesktop !== isDesktop) {
            this.setState({ isDesktop });
        }
    }

    handleFeedbackChange = (e) => {
        this.setState({
            feedbacktext: e.target.value,
            feedbackError: ""
        });
    }

    goBack = () => {
        window.history.back();
    }

    sendFeedback = ()=>{

        if (!this.state.feedbacktext.trim()) {
            this.setState({
                feedbackError: "Please write some feedback"
            });

            setTimeout(() => {
                this.setState({
                    feedbackError: ""
                });
            }, 1000);

            return;
        }

        console.log("Feedback:", this.state.feedbacktext);
        let postdata={
            "feedbacktext": this.state.feedbacktext
        }

        let url = global.api_ci_url + "api/fetchfromCI/sendfeedback"; 

        let currentPath = window.location.pathname;
        let redirectUrl = currentPath.replace('/feedback/', '/');


        // window.location.href = "/tools/baby-growth-tracker-chart/";

        service.postServiceCall(url, postdata)
        .then((json) => { 
            if(json.msg == 1){
                window.location.href = redirectUrl;
            }
           
        })
        .catch((err) => {
            console.log(err);
        });
    }


   render() {
    return (
            <main className="maincontainer1" style={{ height: this.state.activeTab == "ht" ? "auto" : "auto" }} >
                <div className="outerContainer">
                    <div className="main-container FeedbackContainer">
                        <Helmet>
                            <title>Feedback</title>
                            <meta name="description" content="Browse our list of experts in various fields." />
                        </Helmet>


                        <div className="titlegrowthTracker">

                            {this.state.isDesktop &&
                                <div className="breadcrumb R11_9e ">
                                    <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                                    <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                    <span>Tools</span>
                                    <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                    <span>Child Immunization & Baby Growth Tracker</span>
                                    <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                    <span>Feedback</span>
                                </div>
                            }

                             <div className="title_filter">
                                {this.state.isDesktop ? ( 
                                        <span className="R28_21" aria-label="Feedback">Feedback</span>
                                    ):(
                                <span className="mob_Vcc_Title" aria-label="Child Immunization & Baby Growth Tracker">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/left_arrow.png" onClick={()=>this.goBack()} alt="back img"></img>
                                    Feedback
                                </span>
                                )}
                            </div>
                        </div>
                        <hr className="titlehr"></hr>

                        <div className="feedback_container">
                            <div className="feedbackBody">
                                <div className={`feedback_form ${this.state.isDesktop}`} >
                                    <textarea
                                        id="feedbacktext"
                                        name="feedbacktext"
                                        value={this.state.feedbacktext}
                                        onChange={this.handleFeedbackChange}
                                        placeholder="Your feedback is valuable to us which will help us serve you better. Share your feedback about our vaccination Tracker here in 250 characters."
                                    />

                                    <div className="feedback_submitBtn" id="feedback-submit"  onClick={this.sendFeedback}>
                                        <span className="B14_white">Submit</span>
                                        <span className="icon" data-icon-font=""></span>
                                    </div>
                                    {this.state.feedbackError &&
                                        <div className="feedback_error">
                                            {this.state.feedbackError}
                                        </div>
                                    }
                                </div>

                            </div>

                            {this.state.isDesktop && 
                                <div className="advertisementRight">
                                    <div className="rightside">
                                        <div
                                            id="c21ba44c-f89a-460f-bbb9-bc29c66647af"
                                            className="_ap_apex_ad"
                                            style={{ width: "336px", height: "280px" }}
                                        >
                                        </div>
                                    </div> 
                                </div>
                            }
                        </div>











                    </div>
                </div>
            </main>
    );
  }


}
export default Feedback;